import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LoadingOverlay from '../LoadingOverlay';
import { protectionPlanSource } from '../../util/constants';

function ProtectionPlansPenRegistration(props) {
  const { dealer, actions } = props;
  const [showLoader, setShowLoader] = useState(false);

  const registerDealer = () => {
    setShowLoader(true);
    dealer.protectionPlanSource = protectionPlanSource.PEN;
    const route = `/${dealer.id}/protection-plans/providers`;
    actions.registerDealerRequest({ dealer, route });
  };

  return (
    <div>
      <h2>Registration</h2>
      <p>
        Do you want to register <strong>{dealer.name}</strong> with PEN?
      </p>
      <LoadingOverlay active={showLoader}>
        <button
          className="btn btn-primary"
          onClick={() => {}}
          disabled={showLoader}
        >
          Cancel
        </button>
        <button
          className="btn btn-primary"
          onClick={registerDealer}
          disabled={showLoader}
        >
          Register with PEN
        </button>
      </LoadingOverlay>
    </div>
  );
}

ProtectionPlansPenRegistration.propTypes = {
  actions: PropTypes.object,
  dealer: PropTypes.object,
};

export default ProtectionPlansPenRegistration;
